var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { attrs: { id: "tab-hbl" } },
        [
          _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        attrs: { no: "1", "split-button": "", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.command1) + " "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CodeSearching")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyFromTheLastTime"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.CopyFromTheLastTime")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t("SeaExport.CopyFromOtherBill")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.CopyCargoDescriptionAndMarks"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.CopyCargoDescriptionAndMarks"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: Boolean(_vm.form.uuid),
                            expression: "Boolean(form.uuid)"
                          }
                        ],
                        attrs: {
                          no: "2",
                          disabled: _vm.btnPrintDisabled,
                          type: "primary"
                        },
                        on: { click: _vm.originalPrint }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.releaseType === 1
                              ? _vm.$t("SeaExport.PrintTheOriginalBl")
                              : _vm.$t("SeaExport.TelexRelease")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.readonly && _vm.form.state == 2,
                            expression: "readonly&&form.state==2"
                          }
                        ],
                        attrs: { no: "3", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.pm.onSubmitStateEvent()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Unlock")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "4",
                          disabled: _vm.readonly || !_vm.form.uuid,
                          type: "primary"
                        },
                        on: { click: _vm.showAddressFormatDialog }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.AntiTerroristFormattedAddress")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { no: "5", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.oversea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "oversea", $$v)
                          },
                          expression: "form.oversea"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.BlBeReleased")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "6", disabled: _vm.readonly },
                        model: {
                          value: _vm.form.printParam2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam2", $$v)
                          },
                          expression: "form.printParam2"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ClauseOfNoWoodPackingMaterial")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "margin-left": "-20px" },
                        attrs: { no: "7", disabled: _vm.readonly },
                        on: {
                          change: function($event) {
                            return _vm.pm.changeAfrAddress()
                          }
                        },
                        model: {
                          value: _vm.form.chkConsolidationClosed,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "chkConsolidationClosed", $$v)
                          },
                          expression: "form.chkConsolidationClosed"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AFRTheLastBill")))]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: { "label-width": "70px", "label-position": "right" }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                        )
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("Message.Shipper") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "157px", flex: "1" },
                              attrs: { disabled: _vm.readonly, no: "8" },
                              model: {
                                value: _vm.form.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperCode", $$v)
                                },
                                expression: "form.shipperCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "9",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "shipper",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "shipperLine" + count,
                          class:
                            "custom " +
                            _vm.getSenderAndReceiverColor("shipperLine", count)
                        },
                        [
                          _c("cargo-input", {
                            ref: "shipperLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "shipperLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "shipperLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "shipperLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "shipper",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["shipperLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine" + count, $$v)
                              },
                              expression: "form['shipperLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("Message.Consignee") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1" },
                              attrs: { disabled: _vm.readonly, no: "10" },
                              model: {
                                value: _vm.form.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeCode", $$v)
                                },
                                expression: "form.consigneeCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "11",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "consignee",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "consigneeLine" + count,
                          class:
                            "custom " +
                            _vm.getSenderAndReceiverColor(
                              "consigneeLine",
                              count
                            )
                        },
                        [
                          _c("cargo-input", {
                            ref: "consigneeLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "consigneeLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "consigneeLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "consigneeLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "consignee",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["consigneeLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine" + count, $$v)
                              },
                              expression: "form['consigneeLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("Message.Notify") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1", width: "100px" },
                              attrs: { disabled: _vm.readonly, no: "12" },
                              model: {
                                value: _vm.form.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyCode", $$v)
                                },
                                expression: "form.notifyCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "13",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clearSenderAndReceiver(
                                      "notify",
                                      7
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "14",
                                  disabled: _vm.readonly,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onCopy_consignee()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyTheConsignee"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "notifyLine" + count,
                          class:
                            "custom " +
                            _vm.getSenderAndReceiverColor("notifyLine", count)
                        },
                        [
                          _c("cargo-input", {
                            ref: "notifyLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "notifyLine" + count,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "notifyLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "notifyLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "notify",
                                  7,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.form["notifyLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine" + count, $$v)
                              },
                              expression: "form['notifyLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { "label-width": "0" } },
                      [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c("span", { staticStyle: { color: "#404144" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.AgentInfo")))
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: { flex: "1", "text-align": "right" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: {
                                    no: "15",
                                    disabled: _vm.readonly,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clearSenderAndReceiver(
                                        "agentParty",
                                        7
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                              ),
                              _c(
                                "el-dropdown",
                                {
                                  class: _vm.readonly ? "not-click" : "",
                                  attrs: {
                                    no: "16",
                                    disabled: _vm.readonly,
                                    "split-button": "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.commandHandle(_vm.command3)
                                    },
                                    command: function(p) {
                                      _vm.command3 = p
                                      _vm.commandHandle(_vm.command3)
                                    }
                                  }
                                },
                                [
                                  _vm._v(" " + _vm._s(_vm.command3) + " "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "SeaExport.CopyMblConsignee"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyMblConsignee"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "SeaExport.CopyNominatedAgentInfo"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.CopyNominatedAgentInfo"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._l(7, function(count) {
                      return _c(
                        "el-form-item",
                        {
                          key: "agentPartyLine" + count,
                          class:
                            "custom " +
                            _vm.getSenderAndReceiverColor(
                              "agentPartyLine",
                              count
                            )
                        },
                        [
                          _c("cargo-input", {
                            ref: "agentPartyLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "agentPartyLine" + count,
                              "auto-uppercase": _vm.isUppercase,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "agentPartyLine" + count,
                                  count + 1 > 7
                                    ? null
                                    : "agentPartyLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "agentParty",
                                  7,
                                  false
                                )
                              }
                            },
                            model: {
                              value: _vm.form["agentPartyLine" + count],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "agentPartyLine" + count,
                                  $$v
                                )
                              },
                              expression: "form['agentPartyLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { "label-width": "0" } },
                      [
                        _c("span", { staticStyle: { color: "#404144" } }, [
                          _vm._v("ALSO NOTIFY")
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom" },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "17",
                            "text-chars": _vm.maxChars,
                            "warning-count": _vm.warningCount,
                            disabled: !_vm.isEdit,
                            "use-read-only": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                "ALSO NOTIFY",
                                _vm.form.alsoNotify,
                                function(val) {
                                  _vm.form.alsoNotify = val.toUpperCase()
                                },
                                false,
                                null,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.form.alsoNotify,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "alsoNotify", $$v)
                            },
                            expression: "form.alsoNotify"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "125px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.NumberOfPackagesOnBl")
                        }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: { no: "18", precision: 0, min: 0 },
                          on: {
                            change: function($event) {
                              return _vm.pm.quantity_Change()
                            }
                          },
                          model: {
                            value: _vm.form.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantity", $$v)
                            },
                            expression: "form.quantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.packing,
                        attrs: { label: _vm.$t("SeaExport.Package") }
                      },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "19",
                            "default-value": _vm.form.packing
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.packing_Change(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.insideQuantity,
                        attrs: { label: _vm.$t("SeaExport.Pieces2") }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: { no: "20", precision: 0, min: 0 },
                          model: {
                            value: _vm.form.insideQuantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "insideQuantity", $$v)
                            },
                            expression: "form.insideQuantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.insidePacking,
                        attrs: { label: _vm.$t("SeaExport.PiecesType2") }
                      },
                      [
                        _c("cargo-packing-select", {
                          attrs: {
                            no: "21",
                            "default-value": _vm.form.insidePacking
                          },
                          on: {
                            change: function(p) {
                              _vm.form.insidePacking = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "custom " + _vm.variableCss.weight,
                        attrs: { label: _vm.$t("SeaExport.GrossWeight") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: { no: "22", precision: 3, min: 0 },
                              model: {
                                value: _vm.form.weight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "weight", $$v)
                                },
                                expression: "form.weight"
                              }
                            }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "custom " + _vm.variableCss.cubage,
                        attrs: { label: _vm.$t("SeaExport.Cubage") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: { no: "23", precision: 3, min: 0 },
                              model: {
                                value: _vm.form.cubage,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cubage", $$v)
                                },
                                expression: "form.cubage"
                              }
                            }),
                            _c("span", [_vm._v("CBM")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-item-input",
                            class: _vm.readonly ? "input-disabled" : ""
                          },
                          [
                            _c("auto-number-input", {
                              attrs: { no: "24", precision: 3, min: 0 },
                              on: {
                                change: function($event) {
                                  return _vm.pm.txtChargeWeightHandler()
                                }
                              },
                              model: {
                                value: _vm.form.chargeWeight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "chargeWeight", $$v)
                                },
                                expression: "form.chargeWeight"
                              }
                            }),
                            _c("span", [_vm._v("M/T")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class:
                          "label-none custom " +
                          _vm.variableCss.cargoEnglishName,
                        attrs: {
                          label: _vm.$t("queryJob.englishDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "25",
                            disabled: !_vm.isEdit || _vm.textareaDisabled,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("queryJob.englishDescriptionOfGoods"),
                                _vm.form.cargoEnglishName,
                                function(val) {
                                  _vm.form.cargoEnglishName = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.englishNameWarningCount,
                                  maxChar: _vm.englishNameMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoEnglishName", $$v)
                            },
                            expression: "form.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: "label-none custom " + _vm.variableCss.mark,
                        attrs: { label: _vm.$t("SeaExport.Marks") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "26",
                            disabled: !_vm.isEdit || _vm.textareaDisabled,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Marks"),
                                _vm.form.mark,
                                function(val) {
                                  _vm.form.mark = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.markWarningCount,
                                  maxChar: _vm.markMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mark", $$v)
                            },
                            expression: "form.mark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "label-none custom",
                        attrs: {
                          label: _vm.$t(
                            "SeaExport.CapitalizedNumbersOfPackages"
                          )
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "27", disabled: true },
                          model: {
                            value: _vm.form.quantitySum,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantitySum", $$v)
                            },
                            expression: "form.quantitySum"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.TransportInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "HB/L NO2." } },
                      [
                        _c("el-input", {
                          attrs: { no: "28" },
                          model: {
                            value: _vm.form.hblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hblNbr2", $$v)
                            },
                            expression: "form.hblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.warehouseNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "29" },
                          model: {
                            value: _vm.form.warehouseNo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehouseNo", $$v)
                            },
                            expression: "form.warehouseNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.RelatedMbl") } },
                      [
                        _c("cargo-combo-box", {
                          attrs: {
                            no: "30",
                            disabled:
                              _vm.readonly && _vm.splitOrder.rowData.length > 0,
                            options: _vm.pm.joinMBLs,
                            "label-field": "mblNbr2",
                            "value-field": "uuid",
                            "need-old-value": true,
                            "forbid-values": [""]
                          },
                          model: {
                            value: _vm.form.mblId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mblId", $$v)
                            },
                            expression: "form.mblId"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.BillOfLadingNumber") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "31" },
                          model: {
                            value: _vm.form.serialNo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "serialNo", $$v)
                            },
                            expression: "form.serialNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.vessel") } },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "32",
                            disabled: _vm.readonly || !_vm.pm._lclslaveEnabled,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Vessel,
                            filterable: "",
                            "allow-create": _vm.pm._allowEditingVessel,
                            "default-value": _vm.job.vessel
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.onVesselSelectionChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.voyage") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "33",
                              disabled:
                                _vm.readonly || !_vm.pm._lclslaveEnabled,
                              filterable: "",
                              "allow-create": _vm.pm.editVoyageMode === 1
                            },
                            on: {
                              focus: function($event) {
                                return _vm.pm.txtVoyagefocusInHandler()
                              },
                              blur: function($event) {
                                return _vm.pm.txtVoyagefocusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.job.voyageFlight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "voyageFlight", $$v)
                              },
                              expression: "job.voyageFlight"
                            }
                          },
                          _vm._l(_vm.pm._voyages, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.voyageNo,
                                value: item.voyageNo
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.dateOfDeparture") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "34",
                            value: _vm.moment(_vm.job.etd).format("YYYY-MM-DD"),
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.dispatchingPlace,
                        attrs: {
                          label: _vm.$t("SeaExport.DocDispatchingPlace")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "35" },
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.loadingPort,
                        attrs: { label: _vm.$t("SeaExport.PortOfLoadingOnBl") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "36" },
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.dischargingPort,
                        attrs: {
                          label: _vm.$t("SeaExport.PortOfDischargeOnBl")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "37" },
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.destinationPort,
                        attrs: {
                          label: _vm.$t("SeaExport.PlaceOfDeliveryOnBl")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "38" },
                          model: {
                            value: _vm.form.destinationPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPort", $$v)
                            },
                            expression: "form.destinationPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.MethodOfHblPayment") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "39",
                            "select-type":
                              _vm.selectTypeNames.basic_data_PaymentTerm,
                            filterable: "",
                            "default-value": _vm.form.paymentTerm
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.paymentSelectHblChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.PlaceOfHblPayment2") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "40" },
                          model: {
                            value: _vm.form.paymentPlaceBL,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "paymentPlaceBL", $$v)
                            },
                            expression: "form.paymentPlaceBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.TransportationClause")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "41" },
                          model: {
                            value: _vm.job.freightTermHBL,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "freightTermHBL", $$v)
                            },
                            expression: "job.freightTermHBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.blNumber,
                        attrs: { label: _vm.$t("SeaExport.NoOfOriginalBls") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "42" },
                          model: {
                            value: _vm.form.blNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "blNumber", $$v)
                            },
                            expression: "form.blNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PlaceOfIssue") } },
                      [
                        _c("el-input", {
                          attrs: { no: "43" },
                          model: {
                            value: _vm.form.signPlaceBL,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signPlaceBL", $$v)
                            },
                            expression: "form.signPlaceBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DateOfIssue") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "44",
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.signDateBL,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "signDateBL", $$v)
                            },
                            expression: "form.signDateBL"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.remarks,
                        attrs: { label: _vm.$t("SeaExport.BlRemarks") }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "45",
                            disabled: !_vm.isEdit,
                            "text-chars": _vm.maxChars,
                            "warning-count": _vm.warningCount
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.BlRemarks"),
                                _vm.form.remarks,
                                function(val) {
                                  _vm.form.remarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                      [
                        _c("el-input", {
                          attrs: { no: "46", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.HsCode"),
                                _vm.job.hsCode,
                                function(val) {
                                  _vm.job.hsCode = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.hsCode,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "hsCode", $$v)
                            },
                            expression: "job.hsCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ReasonOfCargoDetention")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "47",
                            type: "textarea",
                            rows: 5,
                            disabled: true
                          },
                          model: {
                            value: _vm.form.withholdReason,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "withholdReason", $$v)
                            },
                            expression: "form.withholdReason"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  { attrs: { disabled: _vm.readonly } },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                    ]),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.job.typeHBL ===
                              _vm.BillType.SPLIT_BILL_TYPE.code,
                            expression:
                              "job.typeHBL===BillType.SPLIT_BILL_TYPE.code"
                          }
                        ],
                        staticClass: "label-none custom"
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            no: "48",
                            "grid-options": _vm.splitOrder.gridOptions,
                            "show-side-bar": false,
                            "grid-params": _vm.splitOrder.gridParams,
                            "column-defs": _vm.splitOrder.columnDefs,
                            "row-data": _vm.splitOrderFinalRowData
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(
                                _vm.splitOrder,
                                "gridParams",
                                $event
                              )
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(
                                _vm.splitOrder,
                                "gridParams",
                                $event
                              )
                            },
                            gridReady: function(params) {
                              _vm.splitOrder.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  ref: "splitBtnAdd",
                                  attrs: { no: "49", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onAddCargoDoc2()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.new")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "50", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onRemoveCargoDoc()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.job.typeHBL ===
                              _vm.BillType.MERGE_BILL_TYPE.code,
                            expression:
                              "job.typeHBL===BillType.MERGE_BILL_TYPE.code"
                          }
                        ],
                        staticClass: "label-none custom"
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            no: "51",
                            "grid-options": _vm.mergeOrder.gridOptions,
                            "grid-params": _vm.mergeOrder.gridParams,
                            "column-defs": _vm.mergeOrder.columnDefs,
                            "row-data": _vm.mergeOrderFinalRowData,
                            "show-side-bar": false
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(
                                _vm.mergeOrder,
                                "gridParams",
                                $event
                              )
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(
                                _vm.mergeOrder,
                                "gridParams",
                                $event
                              )
                            },
                            gridReady: function(params) {
                              _vm.mergeOrder.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "52", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onMergeAddJob()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "53", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onMergeRemoveJob()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-position": "right",
                      "label-width": "100px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.BlType") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "54",
                              value: _vm.form.releaseType || ""
                            },
                            on: {
                              input: function(val) {
                                _vm.form.releaseType = val
                              },
                              change: function(val) {
                                _vm.pm.cmbreleaseTypeMBLChangeHandler(val)
                              }
                            }
                          },
                          _vm._l(_vm.blModeList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.name,
                                value: item.serialNumber
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "red",
                        attrs: { label: _vm.$t("SeaExport.CheckingStatus") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "55",
                            value: _vm.lblCfrState,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "red",
                        attrs: { label: _vm.$t("SeaExport.ReleasingStatus") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "56",
                            value: _vm.lblReleaseState,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "6px" },
                            attrs: {
                              no: "57",
                              value: _vm.form.releaseReview === 1,
                              disabled: true
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.DataSent")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "6px" },
                            attrs: {
                              no: "58",
                              value: _vm.form.payable,
                              disabled: true
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Completed")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "0px" },
                            attrs: {
                              no: "59",
                              value: _vm.form.withhold,
                              disabled: true
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CargoDetention")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PaymentDate2") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "60",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.agreePayDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "agreePayDate", $$v)
                            },
                            expression: "form.agreePayDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DateOfCargoDetention")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "61",
                            disabled: true,
                            type: "date",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.form.withholdDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "withholdDate", $$v)
                            },
                            expression: "form.withholdDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ParamRemark") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "62",
                              filterable: "",
                              "allow-create": ""
                            },
                            model: {
                              value: _vm.form.printParam4,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "printParam4", $$v)
                              },
                              expression: "form.printParam4"
                            }
                          },
                          _vm._l(_vm.pm.printParam4Type, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.data }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.GenerationOfABillOfLading2")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "63" },
                            model: {
                              value: _vm.form.printParam5,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "printParam5", $$v)
                              },
                              expression: "form.printParam5"
                            }
                          },
                          _vm._l(_vm.pm.printParam5Type, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.data }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ContainerAmount") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "64", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ContainerAmount"),
                                _vm.form.seaeq,
                                function(val) {
                                  _vm.form.seaeq = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.seaeq,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "seaeq", $$v)
                            },
                            expression: "form.seaeq"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CNTRNOSSEALNOS") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { no: "65", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.CNTRNOSSEALNOS"),
                                _vm.form.container,
                                function(val) {
                                  _vm.form.container = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.container,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "container", $$v)
                            },
                            expression: "form.container"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ShippingCompanySCAC")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "66",
                            value: _vm.job.carrierScac || _vm.txtCarrierScAc,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OverseasAgentSCAC") }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "67",
                            value: _vm.txtBookingAgentScAc,
                            disabled: true
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ShipperContactTelNo")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "68" },
                          model: {
                            value: _vm.form.shipperTel,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperTel", $$v)
                            },
                            expression: "form.shipperTel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.ConsigneeContactTelNo")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "69" },
                          model: {
                            value: _vm.form.consigneeTel,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeTel", $$v)
                            },
                            expression: "form.consigneeTel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.NotifyPartyTelNo") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "50" },
                          model: {
                            value: _vm.form.notifyTel,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyTel", $$v)
                            },
                            expression: "form.notifyTel"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "51",
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                ref: "advanceTextDialogTextarea",
                staticStyle: { height: "320px" },
                attrs: {
                  "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                  disabled: !_vm.isEdit
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "52", type: "primary" },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "53" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("bill-address-dialog", {
            attrs: {
              visible: _vm.billAddressDialog.visible,
              job: _vm.billAddressDialog.job,
              params: _vm.billAddressDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billAddressDialog, "visible", $event)
              },
              callback: _vm.codeSearchCallback
            }
          }),
          _vm.searchJobNoDialog.visible
            ? _c("job-no-transcribe-dialog", {
                attrs: {
                  visible: _vm.searchJobNoDialog.visible,
                  lob: "SI",
                  params: _vm.searchJobNoDialog.params
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.searchJobNoDialog, "visible", $event)
                  },
                  selected: _vm.searchJobNoDialog.selectHandler
                }
              })
            : _vm._e(),
          _c("transcribe-dialog", {
            attrs: { visible: _vm.transcribeDialog.visible, job: _vm.job },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.transcribeDialog, "visible", $event)
              },
              callback: _vm.transcribeCallback
            }
          }),
          _c("address-format-dialog", {
            attrs: {
              visible: _vm.addressFormatDialog.visible,
              params: _vm.addressFormatDialog.params
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addressFormatDialog, "visible", $event)
              }
            }
          }),
          _c("cargo-template-selector-dialog", {
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              ctx: _vm.templateSelectorDialog.ctx,
              category: _vm.templateSelectorDialog.category,
              data: _vm.templateSelectorDialog.data,
              context: _vm.context,
              "pre-print-callback": _vm.prePrintCallback,
              "printed-callback": _vm.printedCallback,
              "v2-check-callback": _vm.v2CheckCallback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              }
            }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "54",
                visible: _vm.editDialog.visible,
                title: _vm.editDialog.title,
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.editDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.chargeItem") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "55",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              filterable: "",
                              "default-value":
                                _vm.editDialog.form.chargeItemId || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.chargeItemId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ChargeClause") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "56",
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              filterable: "",
                              "default-value":
                                _vm.editDialog.form.paymentTermHBL
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.paymentTermHBL = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Message.CurrencyExchangeRateIsNotMaintained1"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "57",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              filterable: "",
                              "default-value": _vm.editDialog.form.currency
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.currency = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ContainerSize") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "58",
                              "select-type":
                                _vm.selectTypeNames.local_cache_EQSize,
                              filterable: "",
                              "default-value": _vm.editDialog.form.eqSize
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.eqSize = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ContainerType") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "59",
                              "select-type":
                                _vm.selectTypeNames.basic_data_EQType,
                              filterable: "",
                              "default-value": _vm.editDialog.form.eqType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.eqType = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.quantity") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "60", precision: 0, controls: false },
                            on: { change: _vm.caculateAmount },
                            model: {
                              value: _vm.editDialog.form.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "quantity", $$v)
                              },
                              expression: "editDialog.form.quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.unitPrice") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "61", precision: 2, controls: false },
                            on: { change: _vm.caculateAmount },
                            model: {
                              value: _vm.editDialog.form.unitRate,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "unitRate", $$v)
                              },
                              expression: "editDialog.form.unitRate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.amount") } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "62", precision: 2, controls: false },
                            on: {
                              change: function($event) {
                                _vm.editDialog.form.unitRate =
                                  _vm.editDialog.form.amount
                              }
                            },
                            model: {
                              value: _vm.editDialog.form.amount,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "amount", $$v)
                              },
                              expression: "editDialog.form.amount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "63", type: "primary" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "64" },
                      on: {
                        click: function($event) {
                          _vm.editDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }